import React, { useEffect, useState } from "react";
import { Card, Modal, Nav, Tab } from "react-bootstrap";
import OTPInput from "react-otp-input";
import MainPagetitle from "../../../layouts/MainPagetitle";
import TransactionTable from "./TransactionTable";

const kyc = (props) => {
  const [showPanModal, setShowPanModal] = useState(false);
  const [pandetails, setPandetails] = useState(null);
  const [showPanDetails, setShowPanDetails] = useState(false);
  const [showAadharModal, setShowAadharModal] = useState(false);
  const [showotpinput, setShowotpinput] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [aadhaarOtpResponse, setAadhaarOtpResponse] = useState(null);
  const [aadharinfo, setAadharinfo] = useState(null);
  const [showaadharinfo, setShowaadharinfo] = useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);
  const [isAadharDisabled, setIsAadharDisabled] = useState(true);
  //
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });

  // RECHARGE MODAL
  const [showrechargemodal, setShowrechargemodal] = useState(false);
  const [showCustomAmountInput, setShowCustomAmountInput] = useState(false);
  const [userbalance, setUserbalance] = useState(null);
  const [balanceData, setBalanceData] = useState(null);

  // TRANSACTION MODAL
  const [showtransmodal, setShowtransmodal] = useState(false);
  const [activeKey, setActiveKey] = useState("this-month");
  const tabData = [
    {
      key: "this-month",
      name: "This Month",
      content: <TransactionTable />,
    },
    {
      key: "last-three-months",
      name: "Last 3 Months",
      content: <TransactionTable />,
    },
    {
      key: "last-six-months",
      name: "Last 6 Months",
      content: <TransactionTable />,
    },
    {
      key: "custom",
      name: "Custom",
      content: <TransactionTable />,
    },
  ];

  // ----------------------------------------------------------------

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  const handleKycList = (item) => {
    console.log({ item });
    if (item.type === "modal") {
      openModal(item?.modalname);
    }
    if (item.linkname === "creditscore") {
      navigate("/app/creditscore");
    }
    if (item.linkname === "servicevendorrecords") {
      navigate("/app/servicevendorrecords");
    }
  };

  const kyclists = [
    {
      title: "PAN Verification",
      charges: 5,
      image: imagepaths.PANplaceholderImg,
      type: "modal",
      modalname: "pan",
    },
    {
      title: "Aadhar Verification",
      charges: 5,
      image: imagepaths.AadharplaceholderImg,
      type: "modal",
      modalname: "aadhar",
    },
    {
      title: "Credit Score",
      charges: 5,
      image: imagepaths.creditplaceholderImg,
      type: "link",
      linkname: "creditscore",
      modalname: "credit-score",
    },
    {
      title: "Service Vendor Records",
      image: imagepaths.creditplaceholderImg,
      type: "link",
      linkname: "servicevendorrecords",
      className_body: "centered-title",
    },
  ];

  const openModal = (modalname) => {
    if (modalname === "pan") {
      setShowPanModal(true);
    }
    if (modalname === "aadhar") {
      setShowAadharModal(true);
    }
  };

  const closePanModal = () => {
    setShowPanModal(false);
    setShowPanDetails(false);
  };

  const closeAadharModal = () => {
    setShowAadharModal(false);
    setShowotpinput(false);
    setOtpValue("");
    setAadhaarOtpResponse(null);
    setIsAadharDisabled(true);
    setShowaadharinfo(false);
    setAadharinfo(null);
  };

  const handlePanVerify = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    let payload = {
      pan: data.pan,
    };
    props.apis.apiGetKycPanDetails(payload).then((res) => {
      console.log({ res });
      setPandetails(res);
      setShowPanDetails(true);
    });
  };

  const handlePanSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closePanModal();
    setShowPanDetails(false);
  };

  // AADHAR
  const handleAadharVerify = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    let payload = {
      aadhaarNumber: data.aadhaarNumber,
    };
    props.apis.apiGetKycAadharOtp(payload).then((response) => {
      setAadhaarOtpResponse(response);
      setShowotpinput(true);
    });
  };

  const handleOTPChange = (otp) => {
    // setOTP(otp);
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {};
    if (
      aadhaarOtpResponse.hasOwnProperty("referenceId") ||
      aadhaarOtpResponse.hasOwnProperty("transactionId")
    ) {
      payload = {
        reference_id: aadhaarOtpResponse?.referenceId,
        transaction_id: aadhaarOtpResponse?.transactionId,
        otp: otpValue,
      };
    } else {
      payload = {
        requestId: aadhaarOtpResponse?.requestId,
        otp: otpValue,
      };
    }
    props.apis.apiGetKycAadharDetails(payload).then((res) => {
      console.log({ res });
      setAadharinfo(res);
      setShowaadharinfo(true);
      setIsAadharDisabled(false);
    });
  };

  const resendOTP = () => {};

  const handleAadharSubmit = (e) => {
    closeAadharModal();
  };

  // RECHARGE MODAL
  const closeRechargeModal = () => {
    setShowrechargemodal(false);
  };

  const handleRechargeAmount = (e) => {
    let key = e[0].key;
    if (key === "others") {
      setShowCustomAmountInput(true);
    } else {
      setShowCustomAmountInput(false);
    }
  };

  const handleRechargeSubmit = (e, data) => {
    e.preventDefault();
    let obj = {
      ...data,
    };
    let payload = {
      profileId: props?.$store?.user?.profileId,
      ...Object.only(obj, ["amount"]),
    };

    if (data?.amount === "others") {
      payload.amount = Number(data.custom_amount);
    } else {
      payload.amount = Number(data.amount);
    }

    // props.apis.apiVasRecharge(payload).then((res) => {
    //   closeRechargeModal();
    //   setBalanceData();
    // });
  };

  // TRANSACTION MODAL
  const closeTransModal = () => {
    setShowtransmodal(false);
  };

  const getUserBalance = () => {
    props.apis.apiAdminGetWalletBalance().then((res) => {
      console.log({ res });
      let balanceAmt = res?.Data?.FundsAvailableResult?.BalanceAmount;
      setBalanceData(balanceAmt);
    });
  };

  const getBackLink = () => {
    return "/app/kyc";
  };

  useEffect(() => {
    getUserBalance();
  }, []);

  props.$setNode({
    props,
    errorMessage,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Know Your Customer"
        backLink={getBackLink()}
        pageIcon={imagepaths.PersonSearchIconActive}
      />
      <div className="container-fluid">
        <div className="kyc_container">
          <h2 className="heading-title">Know Your Customer</h2>
          <div className="row g-4">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="metrics_card">
                <div className="col_left">
                  <img src={imagepaths.walletWhiteIcon} alt="card icon" />
                </div>
                <div className="col_right">
                  {/* <h5 className="card-title">
                    Rs.
                    <div className="amount_box">
                      {balanceData?.cur() || "-"}
                    </div>
                  </h5>
                  <div className="bottom_content">
                    <p className="card-text">
                      <span>Balance</span>
                    </p>
                  </div> */}
                </div>
                <button
                  type="button"
                  className="btn white_btn ms-3"
                  onClick={() => setShowrechargemodal(true)}
                >
                  Recharge Your Wallet
                </button>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6">
              <div className="metrics_card">
                <div className="col_left">
                  <img src={imagepaths.transactionWhiteIcon} alt="card icon" />
                </div>
                <div className="col_right">
                  <h5 className="card-title">Transactions</h5>
                  <div className="bottom_content">
                    <p className="card-text">
                      <span>Details</span>
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn white_btn ms-3"
                  onClick={() => setShowtransmodal(true)}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
          <div className="row g-3 py-4">
            {kyclists?.map((item, i) => {
              return (
                <div
                  className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
                  key={i}
                >
                  <div
                    className="offline_card"
                    onClick={() => handleKycList(item)}
                  >
                    <div className={`body d-flex ${item?.className_body}`}>
                      <img
                        src={item.image}
                        className="img-fluid me-3"
                        alt={item.title}
                      />
                      <div>
                        <h4 className="title d-flex align-items-center">
                          {item.title}
                        </h4>
                        {item.charges && (
                          <p className="m-0">Charge: Rs. {item.charges}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* PAN MODAL */}
      <Modal
        show={showPanModal}
        onHide={closePanModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>PAN Verification</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            {!showPanDetails ? (
              <AppForm onSubmit={handlePanVerify}>
                <AppInput type="text" name="pan" label="Enter PAN No." />
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 mb-3"
                  >
                    Verify
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closePanModal()}
                  >
                    Cancel
                  </button>
                </div>
              </AppForm>
            ) : (
              <div class="profile_details_container">
                <div class="profile_detail mb-3">
                  <p class="m-0">Name as per PAN</p>
                  <h4>{pandetails?.name || "-"}</h4>
                </div>
                {/* <div class="profile_detail mb-3">
                  <p class="m-0">Date of birth as per PAN</p>
                  <h4>{pandetails?.dob || "-"}</h4>
                </div> */}
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 mb-3"
                    onClick={(...args) => handlePanSubmit(...args)}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closePanModal()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* AADHAR MODAL */}
      <Modal
        show={showAadharModal}
        onHide={closeAadharModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Aadhar Verification</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <AppForm onSubmit={handleAadharVerify}>
              <AppInput
                type="text"
                name="aadhaarNumber"
                label="Enter Aadhar No."
              />
              <div
                className={Object.className({
                  "col-12": true,
                  "d-none": showotpinput,
                })}
              >
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-3 mb-3"
                >
                  Verify
                </button>
                <button
                  type="button"
                  className="btn text-primary w-100 py-3"
                  onClick={(e) => closeAadharModal()}
                >
                  Cancel
                </button>
              </div>
            </AppForm>
            <div
              className={Object.className({
                "d-none": !showotpinput,
              })}
            >
              {!showaadharinfo ? (
                <>
                  <div className="col-12 d-flex flex-column">
                    <div className="">
                      <h3 className="">OTP to verify</h3>
                      <p className="">We have sent an OTP to your mobile no.</p>
                    </div>
                    <div className="d-flex">
                      <OTPInput
                        value={otpValue}
                        onChange={(e) => handleOTPChange(e)}
                        separator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                        numInputs={6}
                        shouldAutoFocus={true}
                        isInputNum={true}
                        containerStyle="otp_container small p-0"
                      />
                      <button
                        type="button"
                        className="btn text-primary"
                        onClick={(...args) => handleOtpVerify(...args)}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="text-start otp_bottom">
                      <span className="me-2">Not received OTP?</span>
                      <button
                        className="btn px-0 text-primary fs-5 border-0"
                        disabled={isOtpDisabled}
                        onClick={(e) => resendOTP(e)}
                      >
                        Resend
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="aadhar_info_Card">
                    <ul>
                      <li>
                        <span>Name:</span> {aadharinfo?.fullName || "-"}
                      </li>
                      <li>
                        <span>Date of Birth:</span> {aadharinfo?.dob || "-"}
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary w-100 py-3 mb-3"
                  disabled={isAadharDisabled}
                  onClick={(...args) => handleAadharSubmit(...args)}
                >
                  Submit
                </button>
                <button
                  type="submit"
                  className="btn text-primary w-100 py-3"
                  onClick={(e) => closeAadharModal()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* RECHARGE MODAL */}
      <Modal
        show={showrechargemodal}
        onHide={closeRechargeModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Recharge</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <AppForm onSubmit={handleRechargeSubmit}>
              <AppInput type="email" name="email" label="Email Address" />
              <AppInput type="number" name="phone" label="Phone Number" />
              <AppInput
                type="select"
                name="amount"
                label="Recharge Amount"
                options={_enum.RECHARGE_AMOUNTS}
                onChange={(...args) => handleRechargeAmount(...args)}
                required={true}
              />
              {showCustomAmountInput && (
                <AppInput
                  type="number"
                  name="custom_amount"
                  label="Enter Amount"
                  required={true}
                />
              )}
              <div
                className={Object.className({
                  "col-12 mt-3": true,
                })}
              >
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-3 mb-3"
                >
                  Payment Checkout
                </button>
                <button
                  type="button"
                  className="btn text-primary w-100 py-3"
                  onClick={(e) => closeRechargeModal()}
                >
                  Cancel
                </button>
              </div>
            </AppForm>
          </div>
        </Modal.Body>
      </Modal>

      {/* TRANSACTION MODAL */}
      <Modal
        show={showtransmodal}
        onHide={closeTransModal}
        centered
        backdrop="static"
        className="consent_otp_modal modal-lg"
        size="xl"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Transaction Details</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Tab.Container>
            <Card
              name="custom-tab"
              className="dz-card min-h-[600px] border-0 shadow-none"
            >
              <Tab.Content>
                <Card.Body>
                  {/* <!-- Nav tabs --> */}
                  <div className="custom-tab-1">
                    <Tab.Container
                      defaultActiveKey={activeKey}
                      activeKey={activeKey}
                      onSelect={handleSelect}
                    >
                      <Nav as="ul" className="nav-tabs">
                        {tabData.map((data, i) => (
                          <Nav.Item as="li" key={i}>
                            <Nav.Link eventKey={data.key}>{data.name}</Nav.Link>
                          </Nav.Item>
                        ))}
                      </Nav>
                      <Tab.Content className="pt-4">
                        {activeKey === "this-month" && (
                          <Tab.Pane eventKey="this-month">
                            <TransactionTable keyvalue="this-month" />
                          </Tab.Pane>
                        )}

                        {activeKey === "last-three-months" && (
                          <Tab.Pane eventKey="last-three-months">
                            <TransactionTable keyvalue="last-three-months" />
                          </Tab.Pane>
                        )}

                        {activeKey === "last-six-months" && (
                          <Tab.Pane eventKey="last-six-months">
                            <TransactionTable keyvalue="last-six-months" />
                          </Tab.Pane>
                        )}

                        {activeKey === "custom" && (
                          <Tab.Pane eventKey="custom">
                            <TransactionTable keyvalue="custom" />
                          </Tab.Pane>
                        )}
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Card.Body>
              </Tab.Content>
            </Card>
          </Tab.Container>
          <div className="row g-3 mb-4">
            <div
              className={Object.className({
                "col-12 mt-3 text-end": true,
              })}
            >
              <button
                type="button"
                className="btn btn-sm btn-primary py-3 px-5 fs-3"
                onClick={(e) => closeTransModal(e)}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(kyc);
